import { Alert, Card, Col, Row, Space, Spin } from 'antd';
import React from 'react';
import { Company } from '../../../models/company-interface';
import { CustomerServiceQueries } from '../../../queries/customer-service-queries';
import UsageStatistic from './UsageStatistic';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faUsersCrown } from '@fortawesome/pro-regular-svg-icons';
import { Icon } from '@fortawesome/fontawesome-svg-core';
import { AlertFilled, InfoCircleFilled } from '@ant-design/icons';

interface CommitteeSuiteUsageListProps {
  company: Company | undefined;
  hasFeature: boolean;
}

export default function CommitteeSuiteUsage({
  company, hasFeature
}: CommitteeSuiteUsageListProps) {
    
  const usage = CustomerServiceQueries.useCompanyUsageCommitteeSuite(company!.id)

  if (!company)
    return null;

  return (
    <>
    <Card title={<Space><FontAwesomeIcon icon={faUsersCrown as Icon}/> Committee Suite</Space>}>
        <Spin spinning={usage.isLoading}>
            
    <Row gutter={[16,16]}>
        {hasFeature ?
        usage.data?.map( item => (
            <Col span={12}>
                <UsageStatistic item={item} />
            </Col>
        )) :
        <Alert showIcon message="This company does not have the Committee Suite feature" style={{width: '100%'}}/>
        }
    </Row>
        </Spin>
    </Card>
    </>
  );
}
